/**
 * INS-1557: клиентские шаги 1–3 нормализации промокода партнёра. Шаг 4 (верхний
 * регистр) делает только сервер: `toUpperCase` в JS расходится с .NET на части букв.
 */

export const PARTNER_PROMO_CODE_MIN_LENGTH = 4
export const PARTNER_PROMO_CODE_MAX_LENGTH = 20
/** Граница поля ввода и переноса кода между страницами. */
export const PARTNER_PROMO_CODE_INPUT_MAX_LENGTH = 64

/**
 * Шаг 1: набор `char.IsWhiteSpace` .NET плюс U+FEFF и U+200B. Голый `trim()` не
 * удаляет U+0085 и U+200B, поэтому набор задан явно.
 */
const EDGE_SPACE_CLASS =
  '[\\u0009-\\u000D\\u0020\\u0085\\u00A0\\u1680\\u2000-\\u200B\\u2028\\u2029\\u202F\\u205F\\u3000\\uFEFF]'
const EDGE_SPACE_REGEX = new RegExp(
  `^${EDGE_SPACE_CLASS}+|${EDGE_SPACE_CLASS}+$`,
  'gu'
)
const FORMAT_REGEX = /^(?:[\p{L}\p{Nd}][\p{Mn}\p{Mc}]*|[_-])+$/u
const DEFAULT_IGNORABLE_REGEX = /\p{Default_Ignorable_Code_Point}/u

/** Шаг 1. */
export function trimPartnerPromoCode(value: string | null | undefined): string {
  return (value ?? '').replace(EDGE_SPACE_REGEX, '')
}

/** Шаги 1–2: ключ кэша проверки и тело запроса проверки. */
export function normalizePartnerPromoCodeInput(
  value: string | null | undefined
): string {
  return trimPartnerPromoCode(value).normalize('NFC')
}

/** Шаг 3 для значения после шагов 1–2. */
export function isPartnerPromoCodeFormatValid(normalized: string): boolean {
  const length = [...normalized].length

  return (
    length >= PARTNER_PROMO_CODE_MIN_LENGTH &&
    length <= PARTNER_PROMO_CODE_MAX_LENGTH &&
    FORMAT_REGEX.test(normalized) &&
    !DEFAULT_IGNORABLE_REGEX.test(normalized)
  )
}
